// import {ReactMount as Components} from './Libraries/bootstrap';
import Alpine from 'alpinejs';

import './Libraries/Accordion/listener';
import './Libraries/Aos/listener';
import './Libraries/Article/listener';
import './Libraries/BlockContent/listener';
import './Libraries/Highlighter/listener';
import './Libraries/Lightbox/listener';
// import './Libraries/MegaMenu/listener';
import './Libraries/ReadMore/listener';
import './Libraries/ScrollTo/listener';
import './Libraries/SimpleToggle';
import './Libraries/ShowMore';
import './Libraries/StickyNav';
import './Libraries/Swiper/listener';
import './Libraries/TippyPopUp';
import './Libraries/Typewriter/listener';
import './Libraries/VideoEmbed';
import './Libraries/VideoModal/listener';
import './Libraries/VideoStream/listener';

// Components({
//     Example: () => import('./Libraries/example'),
// });

import {drawerModal} from './components/drawer';
import {copyLink} from './components/copy-link';

window.Alpine = Alpine;

Alpine.data('drawerModal', drawerModal);
Alpine.data('copyLink', copyLink);
Alpine.start();
